<template>
  <div class="cHead">
    <div class="institution">
      <div class="title">会员单位:</div>
      <div class="item" v-for="(item,index) in institutionList" @mouseenter="institutionShow(index)">{{item.typeName}}</div>
    </div>
    <div class="institutionOutBox"  @mouseleave="showFlag = false">
      <div class="institutionHover" v-if="showFlag">
        <div class="title">{{institutionList[index].typeName}}</div>
        <div class="item">
          <div v-for="(tItem,tIndex) in institutionList[index].list" :key="tIndex" v-if="tIndex<19" @click="toDetail(tItem)">{{tItem.title}}</div>
          <div style="color: #225ba0;" v-if="institutionList[index].list.length>19" @click="toList">更多>>></div>
        </div>
      </div>
    </div>
    
    <div class="cFooterContent" @mouseenter="showFlag = false">
      <div>
        <span style="margin-right:40px;">主办单位：中国铁道工程建设协会建设监理专业委员会 </span>
      </div>
      <div>
        <span style="margin-right:20px;">地址：北京市复兴路10号</span>
        <span style="margin-right:20px;">邮编：100844</span>
        <span style="margin-right:20px;">电话：(010)51847442</span>
        <span>传真：(010)51847442</span>
      </div>
      <div>备案号：京ICP备13011762号-4</div>
    </div>
  </div>
</template>

<script>
import { chileType, selArticleByType } from "@/api/main";
export default {
  name: "Footer",
  data(){
    return {
      index: 0,
      showFlag:false,
      institutionList:[]
    }
  },
  mounted(){
    this.getList()
  },
  methods:{
    getList(){
      var that = this
      var data = {
        typeId: '4028b8817f25b0eb017f25b168b90000'
      };
      chileType(data).then((resp) => {
        this.institutionList = resp.data;
        this.institutionList.map(el=>{
          var data = {
            typeId: el.id,
            page: 0,
            size: 20
          };
          selArticleByType(data).then((resp) => {
            var list = resp.data.content
            that.$set(el,'list',list)
          });
        })
      });
    },
    toList(){
      var routeData =  this.$router.resolve({
        path: `/committee/Content`,
        query: {
          type:'会员单位',
          typeId:'4028b8817f25b0eb017f25b168b90000'
        },
      });
      window.open(routeData.href, '_blank');
    },
    toDetail(item){
      var routeData =  this.$router.resolve({
        path: `/committee/Content`,
        query: {
          type:'会员单位',
          typeId:'4028b8817f25b0eb017f25b168b90000',
          articleId: item.id
        },
      });
      window.open(routeData.href, '_blank');
    },
    institutionShow(index){
      this.index = index
      this.showFlag = true
    }
  }
};
</script>

<style scoped>
.cHead {
  width: 100%;
  height: 200px;
  line-height: 32px;
  background-color: #094895;
  position: relative;
  color: #FFF;
  font-size: 16px;
}
.institutionOutBox{
  position: absolute;
  width: 1200px;
  height: 1px;
  top: -1px;
  left: 50%;
  margin-left: -600px;
}
.institutionHover{
  position: absolute;
  bottom: 0;
  left: 50%;
  padding: 20px;
  width: 1160px;
  background: #f1f1f1;
  opacity: 0.9;
  color: #000;
  margin-left: -600px;
}
.institutionHover .title{
  color:#094895;
  line-height:40px;
  font-size:20px;
  font-weight:600;
}
.institutionHover .item{
  display: flex;
  flex-wrap: wrap;
}
.institutionHover .item div{
  width: 270px;
  height: 40px;
  cursor: pointer;
  margin-right: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 40px;
}
.institutionHover .item div:hover{
  color: #225ba0;
}
.cFooterContent{
  width: 1200px;
  border-top: 1px dashed #999393;
  text-align: center;
  margin: 0 auto ;
}
.institution{
  width: 1200px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 0 auto;
}
.institution .item{
  cursor: pointer;
  width: 173px;
  height: 40px;
  margin: 20px 0;
  background: #5f8eba;
  line-height: 40px;
  text-align: center;
  color: #fff;
}
</style>
